import React, { PureComponent } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { CloseEye, OpenEye, VerticalLineIcon } from "../Icons";
import { Button } from "../../UI/form";
import _ from "i18n";
import styles from "./DragDrop.local.scss";
import { Tooltip } from "antd";

class DragDropList extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      items: this.getItems(this.props.items)
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.items !== prevProps.items) {
      this.setState({
        items: this.getItems(this.props.items)
      });
    }
  }

  // fake data generator
  getItems = items => {
    return items.map(k => ({
      id: k.id,
      content: _(`${k.id}`),
      visible: k.visible
    }));
  };

  // a little function to help us with reordering the result
  reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  getItemStyle = (index, isDisabled, isDragging, draggableStyle) => {
    return {
      width: 300,
      height: 38.59,
      fontWeight: 500,
      color: isDisabled ? "#8d8d8d" : "#29394D",
      fontStyle: "normal",
      fontFamily: "Roboto",
      display: "flex",
      borderRadius: 4,
      border: isDragging ? "1px solid #18A0FB" : "",
      userSelect: "none",
      padding: "10px 25px",
      margin: "0 0 11px 0",
      background: isDragging ? "#F3FAFF" : "#FFFFFF",
      marginLeft: index * 10,
      alignItems: "center",
      justifyContent: "start",
      boxShadow: "0px 4px 10px rgba(41, 57, 77, 0.1)",
      ...draggableStyle,
      left: 52
    };
  };

  getListStyle = () => {
    return {
      border: "1px solid #F5F5F5",
      left: 52,
      margin: "8px 8px",
      boxSizing: "border-box",
      borderRadius: 4,
      background: "#F1F2F4",
      padding: "20px 20px 11px 20px"
    };
  };

  onDragEnd = result => {
    let { items } = this.state;
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const newItems = this.reorder(
      items,
      result.source.index,
      result.destination.index
    );

    this.setState({
      items: newItems
    });
  };

  onToggleEnablingItem = selected => {
    let { items } = this.state;
    let i = 0;
    let result = items.map(item => {
      if (item.id === selected.id) {
        if (!selected.visible)
          return {
            id: selected.id,
            content: _(`${selected.id}`),
            visible: !selected.visible
          };
        else {
          items &&
            items.forEach(item => {
              if (!item.visible) i++;
            });
          if (i < 3)
            return {
              id: selected.id,
              content: _(`${selected.id}`),
              visible: !selected.visible
            };
        }
      }
      return item;
    });

    this.setState({
      items: result
    });
  };

  handleReloadCycle = () => {
    this.handleUpdateCycle();
    this.props.handleCloseSideBar();
  };
  handleUpdateCycle = () => {
    this.setState({
      items: this.getItems(this.props.items)
    });
  };

  handleRestoreOrdre = () => {
    let combination = this.state.items.map(item => ({
      id: item.id,
      visible: item.visible
    }));
    this.props.onRestoreCycle(combination);
    this.props.handleCloseSideBar();
  };

  render() {
    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
              style={this.getListStyle()}
            >
              {this.state.items &&
                this.state.items.map((item, index) => (
                  <Draggable key={item.id} draggableId={item.id} index={index}>
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={this.getItemStyle(
                          index,
                          !item.visible,
                          snapshot.isDragging,
                          provided.draggableProps.style
                        )}
                      >
                        <VerticalLineIcon />
                        <div
                          style={{
                            paddingLeft: 10,
                            position: "relative",
                            width: "100%"
                          }}
                        >
                          <div>{item.content}</div>
                          {item.visible ? (
                            <Tooltip placement="bottom" title={_("Cacher")}>
                              <span
                                onClick={() => this.onToggleEnablingItem(item)}
                                className={styles.eye}
                              >
                                <OpenEye />
                              </span>
                            </Tooltip>
                          ) : (
                            <Tooltip
                              onClick={() => this.onToggleEnablingItem(item)}
                              placement="bottom"
                              title={_("Visualiser")}
                            >
                              <span className={styles.eye}>
                                <CloseEye />
                              </span>
                            </Tooltip>
                          )}
                        </div>
                      </div>
                    )}
                  </Draggable>
                ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
        <hr
          style={{ margin: "15px 10px", borderBottom: "1px solid #EAEDF0" }}
        />
        <section
          style={{
            display: "flex",
            justifyContent: "flex-end",
            margin: "20px 7px"
          }}
        >
          <Button
            style={{
              height: 35,
              marginRight: 5,
              padding: "8px 19px",
              background: "white",
              color: "#6D7F92",
              boxSizing: "border-box",
              border: "1px solid rgba(109, 127, 146, 0.7)"
            }}
            onClick={this.handleReloadCycle}
          >
            {_("cancel")}
          </Button>
          <Button
            style={{
              height: 35,
              marginRight: 5,
              padding: "8px 4px",
              background: "#5F9EA0",
              color: "white",
              boxSizing: "border-box",
              border: "1px solid rgba(109, 127, 146, 0.7)"
            }}
            onClick={this.handleUpdateCycle}
          >
            {_("Actualiser")}
          </Button>
          <Button
            type={"success"}
            style={{
              height: 35,
              marginRight: 5,
              padding: "0px 30px",
              background: "#0EBF9E",
              color: "white"
            }}
            loading={this.state.loading}
            onClick={e => this.handleRestoreOrdre()}
          >
            {_("save")}
          </Button>
        </section>
      </DragDropContext>
    );
  }
}

export default DragDropList;



// WEBPACK FOOTER //
// ./src/components/Common/DragDropList/DragDropList.js